module.exports = __webpack_public_path__ + "static/media/04_hero_desktop.97c8bd35.jpg";